import { ApiError, ParamsNotFoundError } from '../../helpers/definedErrors';
import { api } from '../../config';

export const routeStudent = async (params = null) => {
  if (!params) {
    params = JSON.parse(sessionStorage.getItem('spParams'));
    if (!params) {
      console.error('No params were found!');
      throw new ParamsNotFoundError();
    }
  }
  try {
    const url = `v1/hybrid/students/installs/${params.installSid}/exams/${params.examSid}/sessions/${params.sessionSid}/route`;
    const headers = {
      token: params.token,
    };
    const response = await api.put(url, headers);
    return response.data;
  } catch (error) {
    console.log('Error routing student!', { error });
    throw new ApiError();
  }
};

export const getWaitTime = async (params = null) => {
  if (!params) {
    params = JSON.parse(sessionStorage.getItem('spParams'));
    if (!params) {
      console.error('No params were found!');
      throw new ParamsNotFoundError();
    }
  }
  try {
    const url = `v1/installs/${params.installSid}/exams/${params.examSid}/sessions/${params.sessionSid}/waitTime`;
    const headers = {
      token: params.token,
    };
    const response = await api.get(url, headers);
    return response.data;
  } catch (error) {
    console.log('Error routing student!', { error });
    throw new ApiError();
  }
};
